<template>
    <div
        class="mb-3"
        :class="{ 'col-md-3': !showSidebar, 'col-md-4': showSidebar }"
    >
        <div class="template-image-container match-height">
            <div class="box zoom-out">
                <a
                    :href="`/templates/${template.slug}`"
                    class="premium-icon-container"
                >
                    <img
                        :src="template.cover_photo"
                        class="template-thumbnail lazy-image"
                        :alt="template.title"
                    />
                    <img
                        src="/images/premium-icon.svg"
                        v-if="template.template_type === 'premium'"
                        alt="Premium Icon"
                        class="premium-icon"
                    />
                </a>
            </div>
            <h5 class="mb-2 mt-3 template-title">
                <a :href="`/templates/${template.slug}`">
                    {{ template.title | str_limit(30) }}
                </a>
            </h5>
        </div>
    </div>
</template>

<script>
export default {
    props: ["template", "showSidebar"],
};
</script>
